module.exports = __webpack_public_path__ + "static/graffiti-045e1bd0d511715a0c71641f4f52f783.jpg";